import * as React from 'react';
import { useEffect, useState } from 'react';
import { View, Text, StyleSheet, TextInput, TouchableOpacity, Alert, Platform } from 'react-native';
import { LoadingIndicator } from '../../../../components/navigation/controls/LoadingIndicator';

import { DataTable } from 'react-native-paper';
import GlobalStyle, { PRIMARY_COLOUR } from '../../../../../../constants/GlobalStyle';
import { useIsFocused } from "@react-navigation/native";
import { Entypo, Ionicons, SimpleLineIcons  } from '@expo/vector-icons';
import { useDeleteBreakdownPartMutation, useGetBreakdownPartsListQuery } from '@store/services/api/breakdown-api';
import { PagedTableDto } from '@store/services/api/base-api';
import { useDebounce } from '../../../../../../components/helpers/UseDebounce';
import { useDeleteUserMutation, useGetAllEngineersQuery, useGetUsersQuery, userApi } from '@store/services/api/user-api';
import { Picker } from '@react-native-picker/picker';
import { DataTableHeader } from '@web/table/DataTableHeader';


export default function WebUserList({navigation}: {navigation: any}) {
  const [deleteUser, deleteUserResult] = useDeleteUserMutation();
  const isFocused = useIsFocused()

  // Filters 
  const [name, setName] = useState("");
  const [role, setRole] = useState("All");

  const [trigger, usersResult] = userApi.useLazyGetUsersQuery();
  const [page, setPage] = React.useState<number>(0);

  const [sortedColumn, setSortedColumn] = React.useState<string>("Name");
  const [sortedColumnAscending, setSortedColumnAscending] = React.useState<boolean>(true);

  useEffect(() => {
    loadTable();
  }, [page, sortedColumn, sortedColumnAscending])

  // useEffect(() => {
  //   console.log("data");
  //   console.log(usersResult);
  // }, [usersResult.data]);

  const loadTable = () => {
    var dto = new PagedTableDto(page, { 
      name: name,
      role: role,
    }, sortedColumn, sortedColumnAscending);
    trigger(dto);
  
  }

  const resetFilters = () => {
    setName("");
    setRole("All");
  }

  const remove = async (entityId) => {
    if (Platform.OS == 'web') {
      if (confirm("Are you sure you want to delete this user?")) {
        var result = await deleteUser(entityId) as any;
        if (result.error) {
          Alert.alert("Error", "Something went wrong. Please try again");
          return;
        }

        loadTable();
      }
    }
  }

  if (usersResult.isLoading || deleteUserResult.isLoading) {
    return <LoadingIndicator/>
  }

  return (
    <View style={styles.container}>  
      <View style={GlobalStyle.filters}>
        <View style={GlobalStyle.filters__header}>
          <Text style={GlobalStyle.filters__header__text}>Search Filters</Text>
        </View>

        <View style={GlobalStyle.filter__columns}>
          <View style={GlobalStyle.column__flex}>
            <Text style={GlobalStyle.column__header}>Name/Email</Text>
            <TextInput 
              style={[GlobalStyle.column, GlobalStyle.column__input]} 
              placeholder="Name"
              onChangeText={setName}
              value={name}
            />
          </View>

          <View style={GlobalStyle.column__flex}>
            <Text style={GlobalStyle.column__header}>Role</Text>
            <Picker
              style={[GlobalStyle.column, GlobalStyle.column__input]} 
              selectedValue={role}
              onValueChange={(itemValue, itemIndex) => setRole(itemValue)}
              itemStyle={{ height: 50 }}>

              <Picker.Item label="All" value="-1" />
              <Picker.Item key={0} label={'Admin'} value={"Admin"} />
              <Picker.Item key={1} label={'Client'} value={"User"} />
              <Picker.Item key={2} label={'Engineer'} value={"Engineer"} />
            </Picker>
          </View>

          <View style={GlobalStyle.column__flex}>
            <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
              <TouchableOpacity style={GlobalStyle.filter__search__button} onPress={() => loadTable()}>
                <SimpleLineIcons name="magnifier" size={16} color="white" />
              </TouchableOpacity>

              <TouchableOpacity style={GlobalStyle.filter__clear__button} onPress={() => resetFilters()}>
                <SimpleLineIcons name="ban" size={16} color="black" />
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>

       
      <TouchableOpacity onPress={() => navigation.navigate("manage")}>
        <Text style={GlobalStyle.add__new__link}>Add New User</Text>
      </TouchableOpacity>
      

      <DataTable style={GlobalStyle.table}>
      <DataTableHeader
          sortedColumn={sortedColumn}
          sortedColumnAscending={sortedColumnAscending}
          onSorted={(column, ascending) => { setSortedColumn(column); setSortedColumnAscending(ascending); }}
          headers={[
            { text: 'Name ', sortedName: "Name", visible: true },
            { text: 'Email', sortedName: "Email", visible: true },
            { text: 'Role', sortedName: "Role", visible: true },
            { text: 'Company', sortedName: "Company", visible: true },
            { text: 'Option',  visible: true },
          ]}
        />
        { usersResult.data?.list.map((element: any) => {
          return (
                  
            <DataTable.Row key={element.id}>
              <DataTable.Cell>{element.name}</DataTable.Cell>
              <DataTable.Cell>{element.email}</DataTable.Cell>
              <DataTable.Cell>{element.role}</DataTable.Cell>
              <DataTable.Cell>{element.company}</DataTable.Cell>
           
              <DataTable.Cell>
                <View style={{ flexDirection: 'row'}}>
                  <TouchableOpacity onPress={() => navigation.navigate("manage", { userId: element.id })}>
                    <Entypo name="pencil" size={24} color="black" />
                  </TouchableOpacity>

                  <TouchableOpacity onPress={() => remove(element.id) } style={{ marginLeft: 20 }}>
                    <Ionicons name="ios-remove-circle" size={24} color="red" />
                  </TouchableOpacity>
                </View>
                
              </DataTable.Cell>
            </DataTable.Row>
          )
        })}
      </DataTable>
      <DataTable.Pagination
        page={page}
        numberOfPages={usersResult.data?.pagination.totalPages}
        onPageChange={(page) => setPage(page)} 
        //@ts-ignore
        itemsPerPage={usersResult.data?.pagination.pageSize}
        showFastPagination
        optionsLabel={'Rows per page'}
      />

    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    position: 'relative',
    padding: 10,
  },
});
